import { render } from "./QuizPage.vue?vue&type=template&id=d77a25dc&scoped=true"
import script from "./QuizPage.vue?vue&type=script&lang=js"
export * from "./QuizPage.vue?vue&type=script&lang=js"

import "./QuizPage.vue?vue&type=style&index=0&id=d77a25dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d77a25dc"

export default script